<template>
  <v-flex class="search-layout-container">
    <div id="searchPage">
      <v-container id="searchPropertyInput" fluid>
        <h1 v-if="!isMobile">
          Find a Home
        </h1>
        <div
          class="search-tab-container"
          :class="{ 'disabled-state': searchObject.loading }"
        >
          <div
            v-for="item in searchTypeOptions"
            :key="item.value"
            class="search-tab"
            :class="{
              'search-active-tab': searchObject.searchType === item.name
            }"
            @click="$emit('toggle-search-type', item)"
          >
            <span>{{ item.text }}</span>
          </div>
        </div>
        <search-rent-option
          v-if="searchObject.searchType === 'rent'"
          :layout-comps="searchLayoutComps.rent"
          @on-search-clicked="$emit('on-search-clicked')"
        />
        <search-sale-option
          v-else
          :key="searchObject.searchType"
          :layout-comps="searchLayoutComps.sale"
          @on-search-clicked="$emit('on-search-clicked')"
        />
      </v-container>
      <template v-if="!isMobile && profileStatus === 'agent'">
        <v-layout class="auto-search-container">
          <v-flex xs4>
            <div class="auto-search-client-name">
              <span>{{
                isSpecificClient ? `Current client: ${assignToClient.name}` : ""
              }}</span>
            </div>
          </v-flex>
          <v-flex xs4>
            <auto-search-menu
              v-if="clientList.length && !isSpecificClient"
              menu-text="Load Saved Search"
              menu-type="load"
              :menu-options="clientList"
              :menu-color="colors.hwayzDarkGray"
              :menu-width="0"
              @save-load-search="clientSelected($event)"
            />
            <div
              v-else-if="hasSavedAutoSearch"
              class="auto-search-text"
              @click="
                clientSelected({ selectedClient: assignToClient, type: 'load' })"
            >
              <span>LOAD SAVED SEARCH</span>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="auto-search-text">
              <span @click="clearSearchClicked">CLEAR</span>
            </div>
          </v-flex>
        </v-layout>
      </template>
    </div>
  </v-flex>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import SearchSaleOption from './SearchSaleOption.vue'
import SearchRentOption from './SearchRentOption.vue'
import AutoSearchMenu from './components/autoSearch/AutoSearchMenu.vue'
import { isEmpty } from '../../utils/generalUtils'
import { INITIAL_NEW_QUERY } from '../common/searchPropertyConst'
import colors from '../../scss/_colors.scss'

export default {
  components: { SearchSaleOption, SearchRentOption, AutoSearchMenu },

  props: {
    searchTypeOptions: {
      type: Array,
      required: true
    },
    searchLayoutComps: {
      type: Object,
      required: true
    },
    assignToClient: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({ colors }),

  computed: {
    ...mapState('common', ['isMobile', 'searchObject', 'profileStatus']),
    ...mapState('agent', ['agentData']),

    isSpecificClient() {
      return !isEmpty(this.assignToClient)
    },

    clientList() {
      return this.agentData
        ? this.agentData.clients.filter(client => !isEmpty(client.autosearch))
        : []
    },

    hasSavedAutoSearch() {
      return this.assignToClient && !isEmpty(this.assignToClient.autosearch)
    }
  },

  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    ...mapMutations('client', {
      setAssignToClient: 'SET_ASSIGN_TO_CLIENT'
    }),
    ...mapMutations('common', {
      setNewRequestedQuery: 'SET_NEW_REQUESTED_QUERY',
      setSearchResultPage: 'SET_SEARCH_RESULT_PAGE'
    }),

    clientSelected(data) {
      const { selectedClient } = data
      let updatedAgentData = { ...this.agentData }
      updatedAgentData.clients = updatedAgentData.clients.map(client =>
        client._id === selectedClient._id
          ? { ...client, selectedAutoSearch: true }
          : { ...client, selectedAutoSearch: false }
      )
      this.setAgentData(updatedAgentData)
      this.setNewRequestedQuery(selectedClient.autosearch[0].query)
      this.setSearchResultPage(true)
      this.setAssignToClient(selectedClient)
      this.$emit('on-search-clicked')
    },

    clearSearchClicked() {
      let updatedAgentData = { ...this.agentData }
      updatedAgentData.clients = updatedAgentData.clients.map(client => ({
        ...client,
        selectedAutoSearch: false
      }))
      const defaultQuery = JSON.parse(JSON.stringify(INITIAL_NEW_QUERY))
      this.setAgentData(updatedAgentData)
      this.setNewRequestedQuery(defaultQuery)
      this.setAssignToClient({})
      this.$emit('on-search-clicked')
    }
  }
}
</script>

<style lang="sass">
@media only screen and (min-width: 600px)
  .v-select.v-text-field .v-select__selections input
    margin-top: 0 !important

.auto-search-container .v-btn, .auto-search-wrap .v-btn
  box-shadow: none !important
  font-weight: 400 !important

.auto-search-wrap .v-btn
  @media only screen and (max-width: 960px)
    font-size: 1.3rem !important

.auto-search-container .v-btn
  width: 100%

// #searchPage
  // background: url("/img/client-search-back.jpg")
  // background-position: center
  // background-repeat: no-repeat
  // background-size: cover
.search-layout-container
  background-color: $hwayzDarkGray
  padding: 4rem 1.5rem
  position: relative
  @media only screen and (max-width: 450px)
    height: 100vh
    padding: 1rem 1.5rem
  .container
    background: none !important
  &::before
    content: ''
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 0
    pointer-events: none
  h1
    font-size: 3.5rem
    color: white
    letter-spacing: 1px
    margin-bottom: 1rem

.search-tab-container
  display: flex
  padding-top: 2rem
  padding-bottom: 1rem
  @media only screen and (max-width: 600px)
    padding-bottom: 2rem

.search-tab
  font-size: 2rem
  margin-right: 6rem
  color: $hwayzWhite
  text-transform: uppercase
  span
    cursor: pointer
  &.search-active-tab
    color: $hwayzYellow
  @media only screen and (max-width: 600px)
    font-size: 1.8rem
    margin-right: 4rem
    margin-left: 1rem

#searchPropertyInput
  z-index: 1
  position: relative
  padding: 0 1rem 3rem
  @media only screen and (max-width: 600px)
    height: 100%
    display: flex
    flex-direction: column
    input
      text-align: center
    #searchButton
      width: 100%
      div
        width: 100%
</style>
